import { render, staticRenderFns } from "./LandCertification.vue?vue&type=template&id=60fa0617&scoped=true&"
import script from "./LandCertification.vue?vue&type=script&lang=js&"
export * from "./LandCertification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fa0617",
  null
  
)

export default component.exports